import ApiService from "@/services/api.service";

const state = {
  tickets: [],
  ticket: {},
  notifications: [],
  ticketNotifications: [],
  selectedNotification: null,
  unReadTicketNotifications: 0,
};
const getters = {
  getUsers(state) {
    return state.tickets;
  },
  getNotifications(state) {
    return state.notifications;
  },
  getTicketNotifications(state) {
    return state.ticketNotifications;
  },
  getUnreadTicketNotifications(state) {
    return state.unReadTicketNotifications;
  },
  getSelectedNotification(state) {
    return state.selectedNotification;
  },
};
const actions = {
  fetchTickets({ commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("gettickets/", payload)
        .then(({ data }) => {
          commit("setTickets", data.result);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  fetchTicket({ commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("getticketbyid/", {
        id: payload,
      })
        .then(({ data }) => {
          commit("setTicket", data.result);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  createTicket({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("createticket/", payload)
        .then(({ data }) => {
          commit(
            "SET_MESSAGE",
            { content: "Ticket Successfully Created", type: 2 },
            {
              root: true,
            },
          );
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
          reject(e);
        });
    });
  },
  updateTicket({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("updateticket/", payload)
        .then(({ data }) => {
          commit(
            "SET_MESSAGE",
            { content: "Successfully Updated", type: 2 },
            {
              root: true,
            },
          );
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
          reject(e);
        });
    });
  },
  uploadTicketFiles({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("uploadticketfiles/", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
          reject(e);
        });
    });
  },
  fetchNotifications({ commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("getticketcomments/", payload)
        .then(({ data }) => {
          commit("setNotifications", data.result);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  fetchTicketNotifications({ commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("getticketcomments/", {
        ...payload,
        notifications: true,
      }).then(({ data }) => {
        commit("setTicketNotifications", data.result);
        const unread = data.result.filter((item) => !item.is_read).length;
        commit("setUnreadTicketNotifications", unread);
        resolve(data);
      });
    });
  },
};
const mutations = {
  markAllNotificationsAsRead(state) {
    state.ticketNotifications = state.ticketNotifications.map((n) => ({
      ...n,
      is_read: true,
    }));
    state.unReadTicketNotifications = 0;
  },
  setTickets(state, payload) {
    state.tickets = payload;
  },
  setTicket(state, payload) {
    state.ticket = payload;
  },
  setNotifications(state, payload) {
    state.notifications = payload;
  },
  setTicketNotifications(state, payload) {
    state.ticketNotifications = payload;
  },
  setSelectedNotification(state, payload) {
    state.selectedNotification = payload;
  },
  setUnreadTicketNotifications(state, payload) {
    state.unReadTicketNotifications = payload;
  },
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
